// extracted by mini-css-extract-plugin
export default {"feature":"Feature_feature__isoac","titleBox":"Feature_titleBox__RqokT","number":"Feature_number__Y-8nG","title":"Feature_title__Dl9VQ","paragraph":"Feature_paragraph__95yvO"};